// extracted by mini-css-extract-plugin
export default {"engagementName":"DashboardEngaementSummaryCard_engagementName__3GUpc"};